import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { AdminCatalogModel } from 'src/app/model/admin/catalog';
import { CATALOG_CONSTANTS } from './admin-catalog.constants';
import { AdminCatalogService } from './admin-catalog.service';

@Component({
  selector: 'ms-admin-catalog',
  templateUrl: './admin-catalog.component.html',
})
export class AdminCatalogComponent extends BaseComponent {
  readonly screen = CATALOG_CONSTANTS;
  protected setScreen = true;
  catalogs: AdminCatalogModel[] = [];
  dtNameFilter?: string;

  constructor(protected service: AdminCatalogService) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service.getCatalogResult().subscribe(this.setCatalogStore)
    );
  };

  private setCatalogStore = (store: AdminCatalogModel[]) => {
    if (!store || store.length === 0) {
      this.subscriptions.push(
        this.service.readCatalogs().subscribe(this.setCatalogs)
      );
    } else {
      this.setCatalogs(store);
    }
  };

  private setCatalogs = (catalogs: AdminCatalogModel[]) =>
    (this.catalogs = catalogs);
}
